export const APPLY_FOR_NET_30_LINK =
  'https://atlassianpartners.atlassian.net/support#/?inquiry_category=partner_sales_support&partner_sales_support_topic=other_sales_request&reason=apply_for_payment_terms';

export const APPLY_FOR_PAY_BY_STATEMENT_LINK =
  'https://atlassianpartners.atlassian.net/support#/?inquiry_category=partner_sales_support&partner_sales_support_topic=apply_for_payment_terms&reason=apply_for_payment_terms&support_type=customer';

export const UUID_REGEX = /[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}/;

export const COMMERCIAL_PRICE_ELIGIBILITY = 'commercial';

export const MAX_CUSTOMER_CONTACTS = 5;

export const INCREASED_MAX_CUSTOMER_CONTACTS = 50;

export const CCP_SEARCH_MAX_LIMIT = 100;

export const ADDITIONAL_INVOICE_RECIPIENTS = 'Additional invoice recipients';
export const ADDITIONAL_INVOICE_RECIPIENT = 'Additional invoice recipient';
export const INVOICE_CONTACTS = 'Invoice contacts';

export const SUBSCRIPTION_CHARGE_NOTE =
  'In most cases, cards will be charged for a subscription at the start of each billing cycle. Atlassian will keep payment info securely on file.';

export const SEARCH_PAGE_LOADER_OPTIONS = {
  hideFilters: true,
  hideSearchBar: true,
  hideActions: true,
};

export const BILLING_ADMIN_DOMAINS_TO_HIDE = ['connect.atlassian.com'];

export const BILLED_EXTERNALLY = 'Billed separately';

export const GRACE_PERIOD = 'Grace period';

export const CATALOG_PAGE_LOADER_OPTIONS = {
  hideSearchBar: true,
  hideFilters: true,
  hideActions: true,
  filtersCount: 0,
  columnsCount: 3,
};

export const UPDATE_FAILED_MESSAGE = `We couldn't make the update`;

export const STATUSPAGE_ADDON_PRODUCT_ID = 'statuspage-addon';

export const MAX_ROWS_PER_PAGE = 100;

export const STRIPE_PAYMENT_METHOD_TYPES = {
  CARD: 'CARD',
  ACH: 'ACH',
};
